import React from 'react';
import { Loading } from '@ecosystem/ui-lib/core/components/Loading';

const BlockUiComponent = ({ blocking, children }) => {
  const containerStyle = {
    position: 'relative',
    pointerEvents: blocking ? 'none' : 'auto',
    overflowY: 'auto',
    minWidth: '1500px'
   };

  const blockerStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(255, 255, 255, 0.7)',
    zIndex: 1,
    display: blocking ? 'flex' : 'none',
    alignItems: 'center',
    justifyContent: 'center',
  };
    
  return (
    <div style={containerStyle}>
      <div style={blockerStyle}>
        <Loading active={blocking}></Loading>
      </div>
      {children}
    </div>
  );
};

export default BlockUiComponent;